module.exports = __webpack_public_path__ + "img/fa-regular-400.7b9568e6.svg";